import { Box, Button, Card, CardContent, FormControl, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import { AllowedAccess } from 'react-permission-role';

import { ArrowLeftCircle, ArrowRightCircle, Save, X, XCircle } from 'react-feather';
import { HeaderForm } from './HeaderForm';
import { CustomAutocomplete } from 'common';

export const VehicleForm = ({ useFetchInit }) => {

  const {
    globalStates,
    Actions,
    defaultData,
    Forms
  } = useFetchInit
  
  const { FormVehicle: {formState, onInputChange, onSelectSearchChange, onInputChangeForNumber} } = Forms
  const { formOpeningMode} = globalStates
  const {onSubmitFormVehicle, handleClickCloseForm} = Actions

  
  return (
    <AllowedAccess permissions={['49_ADMIN', '146_CATALOGO_VEHICULOS']} renderAuthFailed={<p>Error</p>}>
      <form onSubmit={onSubmitFormVehicle}>
      <div className="content">
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <Grid item xs={12}>
            <Card style={{ zIndex: '1' }}>
              <CardContent>
                <div className="h4 mt-1 mb-1">Formulario de Vehículos</div>
                <div className="border-bottom border-dark"></div>
                <HeaderForm useFetchInit={useFetchInit}/>
                
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                      <label htmlFor="tipo">* Tipo de Vehiculo</label>
                        <TextField
                            id='tipo'
                            name='tipo'
                            value={ formState.tipo }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Tipo de Vehiculo'
                            type='text'
                            variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                            InputProps={{
                                readOnly:  false 
                            }}
                            required
                        />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                      <label htmlFor="marca">* Marca</label>
                        <TextField
                            id='marca'
                            name='marca'
                            value={ formState.marca }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Marca'
                            type='text'
                            variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                            InputProps={{
                                readOnly:  false 
                            }}
                            required
                        />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                      <label htmlFor="modelo">* Modelo</label>
                        <TextField
                            id='modelo'
                            name='modelo'
                            value={ formState.modelo }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Modelo'
                            type='text'
                            variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                            InputProps={{
                                readOnly:  false 
                            }}
                            required
                        />
                    </FormControl>
                  </Grid>
                  
                </Grid>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                      <FormControl fullWidth>
                        <label htmlFor="linea">* Linea</label>
                          <TextField
                              id='linea'
                              name='linea'
                              value={ formState.linea }
                              onChange={ onInputChange }
                              size='small'
                              placeholder='Linea'
                              type='text'
                              variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                              InputProps={{
                                  readOnly:  false 
                              }}
                              required
                          />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <FormControl fullWidth>
                        <label htmlFor="color">* Color</label>
                          <TextField
                              id='color'
                              name='color'
                              value={ formState.color }
                              onChange={ onInputChange }
                              size='small'
                              placeholder='Color'
                              type='text'
                              variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                              InputProps={{
                                  readOnly:  false 
                              }}
                              required
                          />
                      </FormControl>
                    </Grid>

                </Grid>


                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>

                  <Grid item xs={12} sm={12} md={2} lg={2}>
                      <FormControl fullWidth>
                        <label htmlFor="motorCC">* Cilindrada del Motor</label>
                          <TextField
                              id='motorCC'
                              name='motorCC'
                              value={ formState.motorCC }
                              onChange={ onInputChange }
                              size='small'
                              placeholder='Cilindrada del Motor'
                              type='text'
                              variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                              InputProps={{
                                  readOnly:  false 
                              }}
                              required
                          />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <FormControl fullWidth>
                        <label htmlFor="matricula">Matricula</label>
                          <TextField
                              id='matricula'
                              name='matricula'
                              value={ formState.matricula }
                              onChange={ onInputChange }
                              size='small'
                              placeholder='Matricula'
                              type='text'
                              variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                              InputProps={{
                                  readOnly:  false 
                              }}
                          />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <FormControl fullWidth>
                        <label htmlFor="motorNo">* No. de Motor</label>
                          <TextField
                              id='motorNo'
                              name='motorNo'
                              value={ formState.motorNo }
                              onChange={ onInputChange }
                              size='small'
                              placeholder='No. de Motor'
                              type='text'
                              variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                              InputProps={{
                                  readOnly:  false 
                              }}
                              required
                          />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <FormControl fullWidth>
                        <label htmlFor="chasis">* No. de Chasis</label>
                          <TextField
                              id='chasis'
                              name='chasis'
                              value={ formState.chasis }
                              onChange={ onInputChange }
                              size='small'
                              placeholder='No. de Chasis'
                              type='text'
                              variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                              InputProps={{
                                  readOnly:  false 
                              }}
                              required
                          />
                      </FormControl>
                    </Grid>

                </Grid>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                        <label htmlFor="origen">* Origen</label>
                        <CustomAutocomplete 
                            customId="origen"
                            customName="origen"
                            customValue={formState.origen}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'origen', value: value.value }})}
                            customPlaceholder='Origen'
                            customOptions={
                                defaultData.optionsOrigen.map(({ value, label }) => ({
                                    value: value,
                                    name: label
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={(formOpeningMode === 'READONLY') ? true : false}
                        />
                    </FormControl>
                  </Grid>   

                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                        <label htmlFor="disponibilidad">* Estado</label>
                        <CustomAutocomplete 
                            customId="disponibilidad"
                            customName="disponibilidad"
                            customValue={formState.disponibilidad}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'disponibilidad', value: value.value }})}
                            customPlaceholder='Estado'
                            customOptions={
                                defaultData.optionsStatus.map(({ value, label }) => ({
                                    value: value,
                                    name: label
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={(formOpeningMode === 'READONLY') ? true : false}
                        />
                    </FormControl>
                  </Grid> 

                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                      <label htmlFor="costo">* Costo de Adquisición (Q)</label>
                        <TextField
                            id='costo'
                            name='costo'
                            value={ formState.costo }
                            onChange={ onInputChangeForNumber }
                            size='small'
                            placeholder='Costo de Adquisición'
                            type='text'
                            variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                            InputProps={{
                                readOnly:  false 
                            }}
                            required
                        />
                    </FormControl>
                  </Grid>

                </Grid>

                <Box className="text-center" sx={{mt: 7, mb: 7, }}>
                    {(formOpeningMode==='EDITABLE') && (
                      <Button
                          startIcon={<Save/>}
                          variant="contained"
                          className='btn-round'
                          color='primary'
                          type='submit'
                          sx={{ marginRight: 1, marginLeft: 5 }}
                      >
                        {(formState.idvehicle>0) ? 'Actualizar' : 'Guardar'}
                      </Button>
                    )}

                    <Button 
                        endIcon={<X/>}
                        variant="contained"
                        type="button" 
                        className='btn-round'
                        color='error'
                        onClick={handleClickCloseForm} 
                        sx={{ marginRight: 5, marginLeft: 1 }}
                    >
                        Cancelar
                    </Button>

                  </Box>
                
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
      </form>
    </AllowedAccess>
  );
};
